/* OnHold postcards: the corner button pauses and resumes the marquee. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-oh-postcards-toggle]');
    if (!button) return;
    var section = button.closest('.oh-postcards');
    var paused = section.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play postcards' : 'Pause postcards');
  });
})();
